import React from 'react';

import './AddAccounts.scss';

const AddAccounts = ({isLoggedInUserPOA}) =>
    <div className="addAccountsWrapper">
        <h5>Don&apos;t see your accounts?</h5>
        <div className="addAccountsContent">
            <div>
                You need to link additional T. Rowe Price or external accounts to your financial plan by selecting &quot;Add Accounts&quot;
                before having the ability to add them to your advisory accounts. Only <span style={{ whiteSpace: 'nowrap' }}>T. Rowe</span> Price
                accounts can be transfered into the Retirement Advisory service online. Please contact your advisor for more information.
            </div>
            <button
                type='button'
                className={`secondary add-acc-btn ${isLoggedInUserPOA ? 'transfer-button-disabled' : ''}`}
                onClick={() => window.location.replace(`${window.location.origin}${`/usis/advice/fps?from=add-account`}`)}
                disabled={isLoggedInUserPOA}
            >
                Add New Accounts
            </button>
        </div>
    </div>;

export default AddAccounts;
